import React from "react"

import * as styles from "./index.module.scss"

interface Props {
  className?: string
  children?: React.ReactNode
  disabled?: boolean
}

const Tabs = ({ className = "", disabled, ...otherProps }: Props) => {
  return (
    <div
      className={`${styles.tabs} ${className} ${
        disabled ? styles.disabled : ""
      }`}
      role="tablist"
      {...otherProps}
    />
  )
}

export default Tabs
